export default "__VITE_ASSET__hWBiJML7__"